import React, { useMemo } from 'react';

import { StatsItemContainer } from '../StatsItemContainer';
import { Widget } from '../Widget';

/**
 * @typedef {Object} StatsItemsCardProps
 * @property {string} [header]
 * @property {Promise} promise
 * @property {'left' | 'center'} [textAlign]
 * @property {import('react').ReactNode} [subheader]
 */

/**
 * @param {StatsItemsCardProps} props
 */
export const StatsItemsCard = ({ header, promise, textAlign, subheader }) => {
  const cachedPromises = useMemo(() => [promise], [promise]);

  return (
    <Widget header={header} promises={cachedPromises} subheader={subheader}>
      {([responseData]) => {
        const data = responseData?.data ?? responseData;

        const formattedData = data.map(stat => {
          return {
            ...stat,
            valueColor: stat.color
          };
        });

        return <StatsItemContainer items={formattedData} textAlign={textAlign} />;
      }}
    </Widget>
  );
};
